/**
 * @Category Utils
 * @description Returns initials from string.
 * @param {String} value The string to evaluate.
 */
export const getInitials = (value: string) => {
  return value.split(/\s/).reduce((response, word) => (response += word.slice(0, 1)), '');
};
